const types = {
  SET_IS_LOGGED_IN_STATUS: 'SET_IS_LOGGED_IN_STATUS',
  CLEAR_IS_LOGGED_IN_STATUS: 'CLEAR_IS_LOGGED_IN_STATUS',
  SET_ACCOUNT: 'SET_ACCOUNT',
  CLEAR_ACCOUNT: 'CLEAR_ACCOUNT',
  SET_USER_ID: 'SET_USER_ID',
  CLEAR_USER_ID: 'CLEAR_USER_ID',
  SET_TOKEN: 'SET_TOKEN',
  CLEAR_TOKEN: 'CLEAR_TOKEN',
  SET_ORGANIZATION_ID: 'SET_ORGANIZATION_ID',
  CLEAR_ORGANIZATION_ID: 'CLEAR_ORGANIZATION_ID',
  SET_SITE_ID: 'SET_SITE_ID',
  CLEAR_SITE_ID: 'CLEAR_SITE_ID',
  SET_ORGANIZATION: 'SET_ORGANIZATION',
  CLEAR_ORGANIZATION: 'CLEAR_ORGANIZATION',
  SET_TAGS: 'SET_TAGS',
  CLEAR_TAGS: 'CLEAR_TAGS',
  SET_LOGO: 'SET_LOGO',
  CLEAR_LOGO: 'CLEAR_LOGO',
  SET_ACCOUNT_POINTS: 'SET_ACCOUNT_POINTS',
  SET_AZURE: 'SET_AZURE',
  UPDATE_ACCOUNT_LOCATION: 'UPDATE_ACCOUNT_LOCATION',
  ACCEPT_TERMS_OF_SERVICE: 'ACCEPT_TERMS_OF_SERVICE',
  SET_ORGANIZATION_AI_SETTINGS: 'SET_ORGANIZATION_AI_SETTINGS',
  SET_ACCOUNT_ORGANIZATIONS: 'SET_ACCOUNT_ORGANIZATIONS',
  CLEAR_ACCOUNT_ORGANIZATIONS: 'CLEAR_ACCOUNT_ORGANIZATIONS',
  SET_HAS_FETCHED_ACCOUNT_ORGANIZATIONS:
    'SET_HAS_FETCHED_ACCOUNT_ORGANIZATIONS',
  SET_PENDING_ORG_SWITCH: 'SET_PENDING_ORG_SWITCH',
  CLEAR_PENDING_ORG_SWITCH: 'CLEAR_PENDING_ORG_SWITCH',
  SET_ORG_SWITCH_SPLASH: 'SET_ORG_SWITCH_SPLASH',
  CLEAR_ORG_SWITCH_SPLASH: 'CLEAR_ORG_SWITCH_SPLASH',
}

export default types
